// AIAgentify - Main App Component
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { B2BProvider } from './b2b/context/B2BContext';
import B2BLayout from './b2b/components/B2BLayout';
import B2BLogin from './b2b/pages/B2BLogin';
import B2BSignup from './b2b/pages/B2BSignup';
import B2BDashboard from './b2b/pages/B2BDashboard';
import B2BLeads from './b2b/pages/B2BLeads';
import B2BLeadDetail from './b2b/pages/B2BLeadDetail';
import B2BSettings from './b2b/pages/B2BSettings';
import B2BWidgetContent from './b2b/pages/B2BWidgetContent';
import B2BBilling from './b2b/pages/B2BBilling';
import './b2b/B2B.css';

export default function App() {
  return (
    <BrowserRouter>
      <B2BProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<B2BLogin />} />
          <Route path="/signup" element={<B2BSignup />} />
          
          {/* Protected routes - inside B2BLayout */}
          <Route element={<B2BLayout />}>
            <Route index element={<B2BDashboard />} />
            <Route path="dashboard" element={<B2BDashboard />} />
            <Route path="leads" element={<B2BLeads />} />
            <Route path="leads/:leadId" element={<B2BLeadDetail />} />
            <Route path="widget-content" element={<B2BWidgetContent />} />
            <Route path="settings" element={<B2BSettings />} />
            <Route path="settings/*" element={<B2BSettings />} />
            <Route path="billing" element={<B2BBilling />} />
          </Route>
          
          {/* Catch all - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </B2BProvider>
    </BrowserRouter>
  );
}
